import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StrategyPickComponent } from 'src/app/pages/strategy/strategy-pick/strategy-pick.component';

const routes: Routes = [
  {
    path: '',
    component: StrategyPickComponent
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StrategyRoutingModule { }
